import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getViewTournament = (params) => {
    return axios.get(`${backendHost}/api/admin/tournament/view`, {params});
};

export {
    getViewTournament
}